import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {AnswerCompleteness} from '../../rfi-individual-results.calc';
import {RfiAnswerCompletenessComponent} from '../../parts/rfi-answer-completeness/rfi-answer-completeness.component';
import {ReferenceAnswer} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-references-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, RfiAnswerCompletenessComponent],
  host: {class: 'flex flex-col gap-4'},
  templateUrl: './rfi-references-section.component.html',
})
export class RfiReferencesSectionComponent {
  readonly completeness = input.required<AnswerCompleteness>();
  readonly answers = input.required<ReferenceAnswer[]>();
}
